import React, { Component, PropTypes } from 'react';
import { observer, inject } from 'mobx-react';
import { observable, action, toJS } from 'mobx';
import Modal from '../Modal';
import Form, { FormBody, FormActions, SelectInput, TextInput } from '../Form';
import IntervalInput from '../Form/IntervalInput';

@inject('parameterStore', 'parameterTypeStore')
@observer
class ParameterModify extends Component {
  static contextTypes = {
    notify: PropTypes.shape().isRequired,
    router: PropTypes.object.isRequired,
  };

  static propTypes = {
    route: PropTypes.object.isRequired,
    params: PropTypes.shape({
      parameterTypeId: PropTypes.string.isRequired,
      parameterId: PropTypes.string.isRequired,
    }).isRequired,
  };

  slug = '/parameter-type';

  @observable title = '';
  @observable editMode = false;
  @observable parameter = {
    code: '',
    name: '',
    description: '',
    property: 'Continuous',
    table: 0,
    interval: '',
    parameter_type_id: '',
  };

  componentWillMount() {
    const { parameterStore, params: { parameterTypeId, parameterId } } = this.props;

    this.editMode = parameterId !== 'add';
    if (this.editMode) {
      this.title = 'Edit Parameter';
      this.parameter = observable(Object.assign({}, parameterStore.findById(parameterId).asJson));
    } else {
      this.parameter.parameter_type_id = parameterTypeId;
      this.title = 'Add Parameter';
    }
  }

  @action onChange = (e, key) => this.parameter[key] = e.target.value;

  @action handleSave = (e) => {
    e.preventDefault();

    const { parameterStore, parameterTypeStore } = this.props;
    const { notify, router } = this.context;

    const payload = Object.assign({}, toJS(this.parameter));

    (this.editMode ? parameterStore.updateItem(payload) : parameterStore.createItem(payload))
      .then((res) => {
        parameterTypeStore.updateParameter(Object.assign(payload, this.editMode ? {} : { id: res.id }), payload.parameter_type_id);
        router.push(this.slug);
        notify.success();
      })
      .catch(action((err) => {
        console.log(err);
        notify.error(err);
      }));

  }

  render() {
    const { parameterStore, parameterTypeStore, params: { parameterId } } = this.props;

    return (
      <Modal title={this.title} slug={this.slug} isSaving={parameterStore.isSaving} handleSave={this.handleSave}>
        <Form>
          <FormBody>
            {this.editMode && <TextInput label={'Id'} value={parameterId} readOnly />}
            {this.editMode ? <SelectInput
              label={'Parameter Type'}
              value={this.parameter.parameter_type_id}
              onChange={e => this.onChange(e, 'parameter_type_id')}
              options={parameterTypeStore.items}
              fields={{ value: 'id', label: 'name' }}
            /> : <TextInput label='Parameter Type' value={parameterTypeStore.findById(this.parameter.parameter_type_id).name} readOnly />}
            <TextInput label={'Name'} value={this.parameter.name} onChange={e => this.onChange(e, 'name')} />
            <TextInput label={'Code'} value={this.parameter.code} onChange={e => this.onChange(e, 'code')} />
            <TextInput label={'Description'} value={this.parameter.description} onChange={e => this.onChange(e, 'description')} />
            <SelectInput
              label={'Property'}
              value={this.parameter.property}
              onChange={e => this.onChange(e, 'property')}
              options={[
                { name: 'Continuous' },
                { name: 'Accumulative' },
                { name: 'Count' },
                { name: 'Time' },
              ]}
              fields={{ value: 'name', label: 'name' }}
            />
            <SelectInput label='Table' options={parameterStore.tableOptions} value={this.parameter.table} onChange={e => this.onChange(e, 'table')} fields={{ label: 'label', value: 'value' }} />
            <IntervalInput label='Interval' value={this.parameter.interval} onChange={e => this.onChange(e, 'interval')} inMinutes />
          </FormBody>

          <FormActions>
            <button onClick={this.handleSave}>Save</button>
          </FormActions>
        </Form>
      </Modal>
    );
  }
}


export default ParameterModify;



// WEBPACK FOOTER //
// ./src/components/Parameter/ParameterModify.js